import { callAPI } from "../../../lib/common";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import LoadingButton from "../../../components/LoadingButton";
import makeStyles from "@mui/styles/makeStyles";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import BoxActions from "./BoxActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormikTextField from "../../../components/Common/FormikTextField";
import Level2BoxContainer from "./Level2BoxContainer";
import { Level2BoxHeading } from "./Level2BoxHeading";
const useStyles = makeStyles((theme) => ({
    heading: {
        color: theme.palette.secondary.main + " !important", // Because of desktop
        textTransform: "uppercase",
        marginBottom: theme.spacing(4),
        fontSize: "30px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "15px",
        },
    },
    contentText: {
        fontSize: "20px",
        marginBottom: 0,
        [theme.breakpoints.down("sm")]: {
            fontSize: "15px",
        },
    },
    form: {
        textAlign: "center",
        "& h4": {
            marginBottom: theme.spacing(4),
        },
        "& .MuiFormControl-root": {
            marginBottom: theme.spacing(4),
        },
        marginBottom: 0,
    },
    subjectName: {
        color: theme.palette.secondary.main,
        fontSize: "20px",
        marginBottom: theme.spacing(4),
        [theme.breakpoints.down("sm")]: {
            fontSize: "15px",
            marginBottom: theme.spacing(2),
        },
    },
}));
export const CheckIfUserExists = ({ email, codeInfo, handleUserExists, handleUserNotExists, onSetEmail, handleGoBack, }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (React.createElement(Level2BoxContainer, null,
        React.createElement(Formik, { initialValues: { username: email }, validationSchema: formSchema(t), validateOnMount: true, onSubmit: (values, { setSubmitting, setFieldError, setValues }) => {
                const email = values.username.trim();
                setValues(Object.assign(Object.assign({}, values), { username: email }));
                setSubmitting(true);
                callAPI("/sections/prophoto/ajax/user_exists_by_email.php?email=" +
                    encodeURIComponent(email))
                    .then((ret) => {
                    if (ret.error) {
                        setFieldError("username", ret.error);
                    }
                    else if (ret.exists) {
                        onSetEmail(email);
                        handleUserExists();
                    }
                    else {
                        onSetEmail(email);
                        handleUserNotExists();
                    }
                })
                    .finally(() => {
                    setSubmitting(false);
                });
            } }, ({ submitForm, isValid, isSubmitting }) => {
            return (React.createElement(Form, { className: classes.form },
                React.createElement(Level2BoxHeading, null,
                    React.createElement(Trans, null, "Code validated")),
                React.createElement(Box, { mb: 2 },
                    React.createElement("p", { className: classes.contentText },
                        React.createElement(Trans, null, "Please enter your email address to access the photos of")),
                    React.createElement("div", { className: classes.subjectName }, codeInfo.name)),
                React.createElement(Field, { id: "check-user-exists-email", component: FormikTextField, label: t("Email address"), name: "username", variant: "outlined", fullWidth: true, autoFocus: true }),
                React.createElement(BoxActions, null,
                    React.createElement(Button, { type: "button", variant: "outlined", color: "primary", onClick: handleGoBack },
                        React.createElement(Trans, null, "Back")),
                    React.createElement(LoadingButton, { variant: "primary", isLoading: isSubmitting, onClick: submitForm, disabled: !isValid, fullWidth: true, "data-testid": "enter-email-button" },
                        React.createElement(Trans, null, "Ok")))));
        })));
};
const formSchema = (t) => () => {
    return Yup.object().shape({
        username: Yup.string()
            .trim()
            .email(t("Invalid email"))
            .required(t("This is required!")),
    });
};
